import { createAction } from "@ngrx/store";

import { ConnectionStatus } from "./real-time-notifications.model";

const ACTION_PREFIX = "[Real Time Notifications]";

export namespace RealTimeNotificationsAction {
	export const connect = createAction(`${ACTION_PREFIX} Connect`, (url: string) => ({ url }));

	export const connectionSuccess = createAction(`${ACTION_PREFIX} Connection Success`, (customerId: string) => ({
		customerId,
	}));
	export const connectionFailure = createAction(`${ACTION_PREFIX} Connection Failure`);

	export const disconnect = createAction(`${ACTION_PREFIX} Disconnect`);

	export const updateStatus = createAction(`${ACTION_PREFIX} Update Status`, (status: ConnectionStatus) => ({
		status,
	}));

	export const subscribeToChannel = createAction(`${ACTION_PREFIX} Subscribe To Channel`, (channel: string) => ({
		channel,
	}));
}
